import { Viewer } from "./PreviewNewsPc.style";
const PreviewNewsPc = ({ title, date, region, imgSrc, htmlString }) => {
  // 날짜 포맷팅
  function leftPad(value) {
    if (value >= 10) {
      return value;
    }
    return `0${value}`;
  }
  /**
   *
   * @param {Date} source
   * @param {String} delimiter
   * @returns
   */
  function toStringByFormatting(source, delimiter = ".") {
    const year = source.getFullYear();
    const month = leftPad(source.getMonth() + 1);
    const day = leftPad(source.getDate());

    return [year, month, day].join(delimiter);
  }

  /**
   *
   * @param {Date} source
   * @param {String} delimiter
   */
  function toStringByHourFormatting(source, delimiter = ":") {
    const hour = leftPad(source.getHours());
    const min = leftPad(source.getMinutes());

    return [hour, min].join(delimiter);
  }
  return (
    <Viewer>
      <div>{title}</div>
      <div>
        <div>{toStringByFormatting(date)}</div>
        <div>
          <img
            loading="lazy"
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd6a9ee0NewsEvents_2.svg"
            alt=""
          />
        </div>
        <div>{toStringByHourFormatting(date)}</div>
        <div>
          <img
            loading="lazy"
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd6a9ee0NewsEvents_2.svg"
            alt=""
          />
        </div>
        <div>{region}</div>
      </div>
      <div>
        <img loading="lazy" src={imgSrc} alt="" id="preview" />
      </div>
      <div dangerouslySetInnerHTML={{ __html: htmlString }}></div>
    </Viewer>
  );
};

export default PreviewNewsPc;
